import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'bootstrap';
import InspectionList from './InspectionList';
import InspectionType from './InspectionType';
import SectionHeader, { SectionHeaderTypes } from '../../Common/SectionHeader';
import InspectionListNpdes from './InspectionListNpdes';

export default function InspectionCategory({ category, onSelectDoc, viewDoc, downloadDoc, downloadAll }) {
    const [isClosed, setIsClosed] = useState(true);
    const [isGrouped, setIsGrouped] = useState(true);
    const tooltipList = useRef([]);
    useEffect(() => initializeTooltips(category), [category]);
    useEffect(() => handleAddResizeEvent(), []);


    function initializeTooltips(category) {
        const tooltipTriggerList = document.querySelectorAll(`.projectDocType[data-id="${category.key}"] .nameContainer[data-bs-toggle="tooltip"]`);
        const newTooltipList = [...tooltipTriggerList].map(el => {
            return { element: el, tooltip: new Tooltip(el) };
        });

        tooltipList.current = newTooltipList;

        return () => {
            // Dispose tooltips.
            newTooltipList.map(t => t.tooltip.dispose());
        };
    }

    function handleAddResizeEvent() {
        function handleResize() {
            const newTooltipList = tooltipList.current.map(x => {
                if (x.element.offsetWidth >= x.element.scrollWidth) {
                    x.tooltip.disable();
                }
                else {
                    x.tooltip.enable();
                }
                return x;
            });

            tooltipList.current = newTooltipList;
        }

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }

    let contents;
    let itemCount;
    if (category.inspectionTypes.length <= 1 && category.key !== 'npdes') {
        itemCount = `(${category.inspectionTypes[0].documents.length})`;

        contents = !isClosed && (<InspectionList
            categoryKey={category.key}
            inspectionTypeKey={category.inspectionTypes[0].key}
            selected={category.inspectionTypes[0].selected}
            documentList={category.inspectionTypes[0].documents}
            onSelectDoc={onSelectDoc}
            viewDoc={viewDoc}
            downloadDoc={downloadDoc}
            downloadAll={downloadAll} />);
    }
    else if (category.key === 'npdes' && isGrouped) {
        let documents = category.inspectionTypes.reduce((acc, type) => { acc = acc.concat(type.documents); return acc; }, []);
        itemCount = `(${documents.length})`;

        contents = !isClosed && (<InspectionListNpdes
            categoryKey={category.key}
            onSelectDoc={onSelectDoc}
            viewDoc={viewDoc}
            downloadDoc={downloadDoc}
            downloadAll={downloadAll}
            inspectionTypes={category.inspectionTypes}
            selected={category.selected} />);
    }
    else {
        let docCount = category.inspectionTypes.reduce((docCount, inspType) => docCount + inspType.documents.length, 0);
        itemCount = `(${docCount})`;
        contents = !isClosed && category.inspectionTypes.map(inspectionType => (<InspectionType
            key={inspectionType.key}
            categoryKey={category.key}
            inspectionType={inspectionType}
            onSelectDoc={onSelectDoc}
            viewDoc={viewDoc}
            downloadDoc={downloadDoc}
            downloadAll={downloadAll} />));
    }

    let groupInspectionTypes = category.key === 'npdes' && (<span className="cursor-pointer text-nowrap inline" onClick={() => setIsGrouped(!isGrouped)}>
        <i className={`text-sm ${isGrouped ? 'dhicon-check-empty' : 'dhicon-check-2'}`} />
        <div className='inline-grid content-center'>Group by Type</div>
    </span>);

    //**************************************************/
    // Turned off control to group/ungroup inspections
    groupInspectionTypes = undefined;
    //**************************************************/

    let categoryName = (<span className="name">{category.categoryName} {itemCount}</span>);
    switch (category.key) {
        case "npdes":
            categoryName = (<span className="name">Inspections {itemCount}</span>);
            break;
        case "formlibrary":
            categoryName = (<span className="name">Form Library {itemCount}</span>);
            break;
        default:
    }

    let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    let categoryHeader = category && (<SectionHeader sectionHeaderType={SectionHeaderTypes.Secondary} classes="justify-between mb-1">
        <span className="nameContainer w-full cursor-pointer"
            onClick={() => setIsClosed(!isClosed)}
            data-bs-toggle="tooltip" data-bs-placement="top"
            data-bs-title={`${category.categoryName}`}>
            {categoryName}
        </span>
        {groupInspectionTypes}
        <i className={`cursor-pointer ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />
    </SectionHeader>);

    return (
        <div className="inspectionCategoryContainer">
            {categoryHeader}
            {contents}
        </div>
    );
}